import { __assign, __rest } from "tslib";
import React from 'react';
import { useHandleFileChangeWrapper } from './utils';
export var UploadButton = function (_a) {
    var onFileChange = _a.onFileChange, _b = _a.resetOnChange, resetOnChange = _b === void 0 ? true : _b, rest = __rest(_a, ["onFileChange", "resetOnChange"]);
    var handleInputChange = useHandleFileChangeWrapper(resetOnChange, onFileChange);
    return React.createElement("input", __assign({ onChange: handleInputChange, type: 'file' }, rest));
};
